import {Component, EventEmitter, HostListener, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'as-add-items',
  templateUrl: './add-items.component.html',
  styleUrls: ['./add-items.component.scss']
})
export class AddItemsComponent implements OnInit {

  @Input() placeholder
  @Output() addedItemsEmitter = new EventEmitter();
  model;

  constructor() {
  }

  @HostListener('document:keypress', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.key == "Enter" && event.target["id"] == "add-item-component") {
      this.addToList();
    }
  }

  ngOnInit() {
  }

  addToList() {

    let updatedModel = [];
    if (this.model != undefined) {
      this.model.split(',').forEach((e) => {

        if (e.trim() !== '') {
          updatedModel.push(e.trim())
        }
      })
      this.addedItemsEmitter.emit(updatedModel)
      this.model = "";
    }
  }


}

